import { JsonPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { LoginService } from './components/login/service/login.service';
@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  enCryptKey:string="user@123";

  constructor(private router: Router,private service:LoginService) {}

  canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const expectedRoles = route.data['roles'] as string[];
 
    if (!expectedRoles) {
      return true; // No specific roles required, allow access
    }

    let user = localStorage.getItem("user");
    if(user){
      var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
        const userRole = JSON.parse(data);
      if (this.service.isAuthorizedUser && expectedRoles.includes(userRole['role'].toString())) {
        return true;
      } else {
        this.router.navigate(['main/unauthorized']);
        return false;
      }
    }

    return true;
  }
}
